import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';
 

export interface GetAccountCollectionsListVars {
    awsAccountId: String;
}

const GET_ACCOUNT_COLLECTION_LIST = gql`
    query GetAccountCollectionsList(
            $awsAccountId: String
        ){
        getAccountCollectionsList(
            awsAccountId: $awsAccountId
        )
    }
`;
 
export const useGetAccountCollectionsListQuery = () => {
    return useLazyQuery<AnyObject, GetAccountCollectionsListVars>(GET_ACCOUNT_COLLECTION_LIST, {
        errorPolicy: 'all',
    });
};
